module.exports = __webpack_public_path__ + "img/l_s2.f46cc470.png";